import React from 'react';
import cn from 'classnames';
import { Link } from '@landing/ui';
// eslint-disable-next-line import/no-webpack-loader-syntax
import Instagram from '!svg-react-loader!./assets/instagram-footer.svg';
// eslint-disable-next-line import/no-webpack-loader-syntax
import Linkedin from '!svg-react-loader!./assets/linkedin-footer.svg';
// eslint-disable-next-line import/no-webpack-loader-syntax
import Facebook from '!svg-react-loader!./assets/fb-footer.svg';

import * as styles from './SocialMediaIcon.module.scss';

function SocialMediaIcon({ theme }) {
  return (
    <div>
      <Link href="https://instagram.com/andersen.global" className={styles.link}>
        <Instagram className={cn(styles.icon, theme && styles[theme])} />
      </Link>
      <Link href="https://www.linkedin.com/company/andersenpeople" className={styles.link}>
        <Linkedin className={cn(styles.icon, theme && styles[theme])} />
      </Link>
      <Link href="https://www.facebook.com/Andersensoft" className={styles.link}>
        <Facebook className={cn(styles.icon, theme && styles[theme])} />
      </Link>
    </div>
  );
}

export default SocialMediaIcon;
